<template>
    <div>
        <ValidationObserver ref="datatableFilterFormValidate">


        <slot name="header" :columns="datatable.columns"></slot>

        <datatable-filter v-show="datatable.filterStatus"
                          @filter="filter"
                          :filterButton="false"
                          @filterClear="filterClear"
                          :otherButton="statusChangeObj"
                          :exportExcel="checkPermission('reservation_classroommatrix')"
                          @exportExcel="exportExcel"
                          @getClassroomMatrix="getRows"
        >
            <b-row>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('campus')">
                        <campus-selectbox v-model="datatable.queryParams.filter.campus_id"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('building')">
                        <building-selectbox v-model="datatable.queryParams.filter.building_id"
                                            :campus_id="datatable.queryParams.filter.campus_id"
                        />
                    </b-form-group>

                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('classroom')">
                        <classroom-selectbox
                            v-model="datatable.queryParams.filter.classroom_id"
                            :building_id="datatable.queryParams.filter.building_id"
                            />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('classroom_types')">
                        <parameter-selectbox
                            code="classroom_types"
                            v-model="datatable.queryParams.filter.classroom_types"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="4">
                    <b-form-group :label="$t('start_date') + ' / ' + $t('end_date')">
                        <ValidationProvider name="date" rules="required" v-slot="{valid, errors}">
                            <v-date-picker
                                v-model="datatable.queryParams.filter.date"
                                is-range
                                :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="border rounded-sm p-1 p-md-3 d-flex align-items-center" :class="errors[0] ? 'box-border-color':''">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input
                                                    :value="inputValue.start"
                                                    v-on="inputEvents.start"
                                                    :placeholder="$t('start_date')"
                                                    class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input
                                                    :value="inputValue.end"
                                                    v-on="inputEvents.end"
                                                    :placeholder="$t('end_date')"
                                                    class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </template>
                            </v-date-picker>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>

        </ValidationObserver>
        <b-row v-if="classroomMatrixLoading">
            <b-col>
                <b-card  class="text-center">
                    <Loading :show="classroomMatrixLoading" :description-show="true" />
                </b-card>
            </b-col>

        </b-row>
    </div>
</template>
<script>
    // Component
    import BuildingSelectbox from '@/components/interactive-fields/BuildingSelectbox'
    import CampusSelectbox from '@/components/interactive-fields/CampusSelectbox'
    import CommonModal from '@/components/elements/CommonModal'
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'

    // Pages

    // Services
    import ReservationService from '@/services/ReservationService'

    // Other
    import qs from 'qs'
    import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";

    export default {
        components: {
            ClassroomSelectbox,
            BuildingSelectbox,
            CampusSelectbox,
            CommonModal,
            DatatableFilter,
            Datatable,
        },
        data() {
            return {
                statusChangeObj: {
                    show: () => {
                        return true
                     },
                    emit: 'getClassroomMatrix',
                    title: this.$t('show'),
                    icon: 'ri-swap-2-line',
                    class:"bg-primary text-white mr-2 mb-2 ml-2 ml-xl-0"
                },
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-edit-box-line',
                                    permission: 'reservation_weeklyprogram',
                                    hidden: false,
                                    callback: ({id,name}) => {
                                        this.showFormShow(id,name);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase(this.spaceToBR(this.$t('campus'))),
                            field: 'campus_name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'campus_name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('building')),
                            field: 'building_name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'building_name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom_name')),
                            field: 'name',
                            sortable: false,
                            formatFn: (value, row) => {
                                return this.getLocaleText(row, 'name', '-')
                            },
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom_types')),
                            field: this.getLocaleField('type_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('classroom')),
                            field: 'capacity',
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:false
                        },
                        {
                            label: this.toUpperCase(this.$t('seating_types')),
                            field: this.getLocaleField('seating_type_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                        // {
                        //     label: this.toUpperCase(this.$t('board_types')),
                        //     field: 'board_type',
                        //     sortable: false,
                        //     thClass: 'text-center',
                        //     tdClass: 'text-center'
                        // },
                        {
                            label: this.toUpperCase(this.$t('display_systems')),
                            field: this.getLocaleField('display_system_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            formatFn: (value, row) => {
                                return row.sound_system === "yes" ? this.$t('yes') :this.$t('no');
                            },
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('sound_systems')),
                            field: this.getLocaleField('sound_system_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            formatFn: (value, row) => {
                                return row.sound_system === "yes" ? this.$t('yes') :this.$t('no');
                            },
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('hybrid_statuses')),
                            field: this.getLocaleField('hybrid_status_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                        {
                            label: this.toUpperCase(this.$t('technological_materials')),
                            field: this.getLocaleField('technological_material_name'),
                            sortable: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            hidden:true
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {
                            campus_id: null,
                            building_id: null,
                            name: null,
                            classroom_types: null,
                            start_date:null,
                            end_date:null
                        },
                        page: 1,
                        limit: 20
                    }
                },
                formId: null,
                formProcess: null,
                classroomMatrixLoading:false,
                classroom_name: ''
            }
        },
        mounted() {
            this.$emit('send-columns', this.datatable.columns);
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {
                    campus_id: null,
                    building_id: null,
                    name: null,
                    classroom_types: null,
                    start_date:null,
                    end_date:null
                }
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
           async  getRows() {
                const isValid =await this.$refs.datatableFilterFormValidate.validate()
                if (!isValid)return
                this.classroomMatrixLoading = true;

                if (this.datatable.queryParams.filter.date) {
                    this.datatable.queryParams.filter.start_date = this.datatable.queryParams.filter.date.start;
                    this.datatable.queryParams.filter.end_date = this.datatable.queryParams.filter.date.end;
                   delete this.datatable.queryParams.filter.date
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };
                return ReservationService.classroomMatrix(config)
                                         .then((response) => {
                                             const newWindow = window.open('', '_blank');
                                             newWindow.document.write(response.data);
                                             newWindow.document.close();
                                         })
                                         .catch((e) => {
                                             this.showErrors(e,this.$refs.datatableFilterFormValidate);
                                         })
                                         .finally(() => {
                                             this.classroomMatrixLoading = false;
                                         });
            },

            formClear() {
                this.formId = null
                this.formProcess = null
            },
           async exportExcel(){
               const isValid =await this.$refs.datatableFilterFormValidate.validate()
               if (!isValid)return
               if (this.datatable.queryParams.filter.date) {
                   this.datatable.queryParams.filter.start_date = this.datatable.queryParams.filter.date.start;
                   this.datatable.queryParams.filter.end_date = this.datatable.queryParams.filter.date.end;
                   delete this.datatable.queryParams.filter.date
               }

               const config = {
                   params: {
                       ...this.datatable.queryParams,
                       response_type:'excel',
                   },
                   responseType : 'arraybuffer',

                   paramsSerializer: (params) => qs.stringify(params, {encode: false})
               };
               return ReservationService.classroomMatrix(config)
                   .then((response) => {
                       this._downloadFile(response, this.$t("classroom_matrix") + '.xlsx')
                   })
                   .catch((e) => {
                       this.showErrors(e,this.$refs.datatableFilterFormValidate);
                   })

            },

            // Show Form
            showFormShow(id,name) {
                this.formId = id
                this.classroom_name = name
                this.formProcess = 'show'
                this.$refs.showFormModal.$refs.commonModal.show()
            },
            getColumns() {
                return this.columns;
            }
        }
    }
</script>
